"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentTokensStyles = exports.tokenStyles = exports.componentPropsStyles = exports.componentExampleStyles = exports.componentContentFrameStyles = void 0;
const lit_1 = require("lit");
const constants_1 = require("@/constants");
const utils_1 = require("@/utils");
const exampleWidthTokens = {
    narrow: { '--component-content-max-width': 'var(--layout-width-narrow)' },
};
exports.componentContentFrameStyles = (0, lit_1.css) `
  /* 프레임 안 콘텐츠는 폭이 들쭉날쭉하지 않도록 좁은 폭을 기본으로 두고, 넓어야 하는 시연만 full-width로 푼다. */
  :host {
    --component-content-max-width: calc(var(--size-80) * 6);
  }

  :host([full-width]) {
    --component-content-max-width: none;
  }

  ::slotted(*) {
    max-width: var(--component-content-max-width);
  }

  .component-content-frame {
    --component-content-offset-inline-start: calc(
      var(--layout-padding-inline) * -1 + var(--space-4)
    );
    --component-content-padding-block: var(--space-8);
    --component-content-padding-inline: calc(var(--layout-padding-inline) - var(--space-4));
    --component-content-bleed-inline: calc(var(--layout-padding-inline) * -1);
    --component-content-frame-margin: 0 0 0 var(--component-content-offset-inline-start);
    --component-content-frame-border: var(--border);
    --component-content-frame-border-radius: var(--radius-large);

    position: relative;
    margin: var(--component-content-frame-margin);
    padding: var(--component-content-padding-block) var(--component-content-padding-inline);
    border: var(--component-content-frame-border);
    border-radius: var(--component-content-frame-border-radius);
  }

  @media ${constants_1.MEDIA.default} {
    .component-content-frame {
      --component-content-padding-inline: var(--layout-padding-inline);

      margin-inline: var(--component-content-bleed-inline);
      border-inline: 0;
      border-radius: 0;
    }
  }
`;
exports.componentExampleStyles = [
    exports.componentContentFrameStyles,
    (0, lit_1.css) `
    :host {
      display: block;
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('width', exampleWidthTokens))}

    .component-example {
      --component-content-frame-margin: 0 0 var(--space-4)
        var(--component-content-offset-inline-start);

      box-sizing: border-box;
      border-left-color: var(--foreground-color);
    }
  `,
];
exports.componentPropsStyles = [
    exports.componentContentFrameStyles,
    (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }
    .component-props {
      height: 10rem;
      overflow: hidden;
      background-color: var(--background-subtle-color);
      position: relative;
      cursor: pointer;
      --component-content-frame-border: var(--border-transparent);
    }
    .component-props-list {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }
    .component-props-more {
      display: flex;
      padding: 0.75rem var(--component-content-padding-inline) 2rem;
      background-color: inherit;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
    }
    :host([open]) .component-props {
      height: auto;
      cursor: default;
    }
    :host([open]) .component-props-more {
      display: none;
    }
  `,
];
exports.tokenStyles = [
    (0, lit_1.css) `
    .token-row {
      display: flex;
      align-items: center;
      gap: var(--space-3);
    }

    .token-category {
      width: 100px;
    }
  `,
];
exports.componentTokensStyles = [
    (0, lit_1.css) `
    .token-list {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }
  `,
    exports.componentContentFrameStyles,
    (0, lit_1.css) `
    :host {
      display: block;
      margin-top: var(--space-4);
    }
  `,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbXBvbmVudC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQW9DO0FBRXBDLDJDQUFtQztBQUNuQyxtQ0FBbUU7QUFFbkUsTUFBTSxrQkFBa0IsR0FBOEI7SUFDcEQsTUFBTSxFQUFFLEVBQUUsK0JBQStCLEVBQUUsNEJBQTRCLEVBQUU7Q0FDMUUsQ0FBQTtBQUVZLFFBQUEsMkJBQTJCLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O1dBZ0NuQyxpQkFBSyxDQUFDLE9BQU87Ozs7Ozs7OztDQVN2QixDQUFBO0FBRVksUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxtQ0FBMkI7SUFDM0IsSUFBQSxTQUFHLEVBQUE7Ozs7O01BS0MsSUFBQSxlQUFTLEVBQUMsSUFBQSwyQkFBbUIsRUFBQyxPQUFPLEVBQUUsa0JBQWtCLENBQUMsQ0FBQzs7Ozs7Ozs7O0dBUzlEO0NBQ0YsQ0FBQTtBQUVZLFFBQUEsb0JBQW9CLEdBQUc7SUFDbEMsbUNBQTJCO0lBQzNCLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQW1DRjtDQUNGLENBQUE7QUFFWSxRQUFBLFdBQVcsR0FBRztJQUN6QixJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7OztHQVVGO0NBQ0YsQ0FBQTtBQUVZLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsSUFBQSxTQUFHLEVBQUE7Ozs7OztHQU1GO0lBQ0QsbUNBQTJCO0lBQzNCLElBQUEsU0FBRyxFQUFBOzs7OztHQUtGO0NBQ0YsQ0FBQSJ9